module.exports = __webpack_public_path__ + "static/bastian-bf180aba082f2bfcc627a72456c36375.png";